import { render, staticRenderFns } from "./management.vue?vue&type=template&id=57ab8763&scoped=true"
import script from "./management.vue?vue&type=script&lang=js"
export * from "./management.vue?vue&type=script&lang=js"
import style0 from "./management.vue?vue&type=style&index=0&id=57ab8763&prod&scoped=true&lang=css"
import style1 from "./management.vue?vue&type=style&index=1&id=57ab8763&prod&lang=stylus"
import style2 from "./management.vue?vue&type=style&index=2&id=57ab8763&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ab8763",
  null
  
)

export default component.exports